import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import type { PlatformModule } from "@yatta/tenant-config";
import { useTenantRuntime } from "../config/TenantRuntime";

interface RequireModulesProps {
  modules: readonly PlatformModule[];
  children: ReactNode;
}

/**
 * Keeps a tenant from reaching a vertical module only by typing its URL.
 * This complements navigation visibility; it is not a substitute for server-side RLS.
 */
export function RequireModules({ modules, children }: RequireModulesProps) {
  const { hasModule, loading } = useTenantRuntime();

  if (loading) {
    return <div className="public-page">Carregando configuração da organização…</div>;
  }

  if (!modules.every((module) => hasModule(module))) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
